import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=daa7fdfc&scoped=true&lang=pug"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa7fdfc",
  null
  
)

export default component.exports